export default "__VITE_ASSET__Cc1bRyE9__"